export const GRANTS_I18N_ENTRIES = {
  grants_Data1: {
    es: '<p>Entidad beneficiaria SMARTMAKINGS S.L.</p><p>Importe subvención: 7.500,00 Euros</p><p>Cofinanciación europea: 85%</p><p>Nº Expediente FEI/5515/C24</p><p>Fondo Social Europeo Plus</p><p>Prioridad 1 “Empleo, adaptabilidad,</p><p>emprendimiento y economía social”</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  grants_Data2: {
    es: '<p>Más información</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  grants_Data3: {
    es: '<p>Smartmakings S.L. ha recibido una ayuda pública por importe de 7.500,00 euros, destinada a fomentar la contratación indefinida de personas desempleadas con especiales dificultades de acceso al mercado de trabajo. Esta subvención está cofinanciada en un 85 % por la Unión Europea a través del Fondo Social Europeo Plus (FSE+), en el marco del Programa FSE+ Extremadura 2021-2027.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  grants_Data4: {
    es: '<p>Esta actuación se enmarca dentro de las políticas activas de empleo de la Junta de Extremadura, orientadas a facilitar el acceso al empleo a quienes se encuentran en situación de desempleo, especialmente aquellos colectivos con mayores barreras para su inserción laboral. A través del presente decreto, se refuerzan los instrumentos de apoyo a la contratación indefinida como vía para avanzar hacia un modelo laboral más inclusivo y estable. La medida se alinea con los objetivos establecidos en la Estrategia de Empleo y Competitividad Empresarial de Extremadura 2020-2025, que persigue aumentar la participación de hombres y mujeres en el mercado laboral, reducir el desempleo estructural y fomentar un empleo de calidad. El apoyo financiero del FSE+, en el marco del Reglamento (UE) 2021/1057, permite a esta iniciativa contribuir a los objetivos específicos del Fondo, como la mejora del acceso al empleo de personas desempleadas de larga duración o en situación de vulnerabilidad, garantizando condiciones laborales justas y favoreciendo la inclusión social. Con esta ayuda, Smartmakings S.L. reafirma su compromiso con la generación de empleo estable y con la mejora de las oportunidades laborales en Extremadura, contribuyendo activamente a los objetivos compartidos de cohesión económica y social en el ámbito europeo.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  grants_Data5: {
    es: '<p>Nº Expediente FEI/5515/C24</p><p>Fondo Social Europeo Plus</p><p>Prioridad 1 “Empleo, adaptabiliddad, emprendimiento</p><p>y economía social”</p><p>Entidad beneficiaria SMARTMAKINGS S.L.</p><p>Importe subvención: 7.500,00 Euros</p><p>Cofinanciación europea: 85%</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
};
